const detail = {
  path: 'detail',
  component: resolve => require(['../../../../../pages/admin/agentMessage/detail'], resolve),
  meta: {
    requireAuth: true
  }
}

export default detail
